/**
 * EF-GLOBAL-PAGE-ZOOM-FIX-V1
 * 
 * Global page zoom wrapper component that applies CSS transform scaling
 * to the entire page content. This ensures all elements (text, tables,
 * buttons, inputs) scale proportionally.
 * 
 * Usage:
 *   const { scale } = useZoom('page-key');
 *   <PageZoomContainer scale={scale}>
 *     <PageHeader ... />
 *     <CardContainer ... />
 *   </PageZoomContainer>
 */
import React from 'react';

export default function PageZoomContainer({ scale = 1, children, className = '' }) {
  // When scale is 1 (100%), don't apply transform for better performance
  if (scale === 1) {
    return (
      <div className={className} data-testid="page-zoom-container">
        {children}
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${100 / scale}%`,
      }}
      data-testid="page-zoom-container"
    >
      {children}
    </div>
  );
}

export { PageZoomContainer };
